export default "__VITE_ASSET__IL8LoSeX__"